import React, { useState, useEffect } from 'react';
import { notificationService } from '../services/notificationService';
import { Notification } from '../types';

const NotificationContainer: React.FC = () => {
  const [notifications, setNotifications] = useState<Notification[]>([]);

  useEffect(() => {
    const unsubscribe = notificationService.subscribe(setNotifications);
    return unsubscribe;
  }, []);

  const handleDismiss = (id: string) => {
    notificationService.remove(id);
  };

  const getAlertClass = (type: string) => {
    switch (type) {
      case 'success':
        return 'alert-success';
      case 'error':
        return 'alert-danger';
      case 'warning':
        return 'alert-warning';
      case 'info':
      default:
        return 'alert-info';
    }
  };

  const getIcon = (type: string) => {
    switch (type) {
      case 'success':
        return 'bi-check-circle';
      case 'error':
        return 'bi-exclamation-triangle';
      case 'warning':
        return 'bi-exclamation-triangle';
      case 'info':
      default:
        return 'bi-info-circle';
    }
  };

  if (notifications.length === 0) {
    return null;
  }

  return (
    <div
      style={{
        position: 'fixed',
        top: '20px',
        right: '20px',
        zIndex: 9999,
        minWidth: '300px',
        maxWidth: '400px',
      }}
    >
      {notifications.map((notification, index) => (
        <div
          key={notification.id}
          className={`alert ${getAlertClass(notification.type)} alert-dismissible fade show`}
          style={{
            marginBottom: '10px',
            animation: 'slideInRight 0.3s ease',
            boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1)',
            border: 'none',
            borderRadius: '0.5rem',
          }}
        >
          <div className="d-flex align-items-start">
            <i className={`bi ${getIcon(notification.type)} me-2 mt-1`}></i>
            <div className="flex-grow-1">
              <div dangerouslySetInnerHTML={{ __html: notification.message }} />
            </div>
            <button
              type="button"
              className="btn-close"
              onClick={() => handleDismiss(notification.id)}
              style={{ fontSize: '0.75rem' }}
            ></button>
          </div>
        </div>
      ))}
    </div>
  );
};

export default NotificationContainer;
